import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { PhoneUtil } from '@xengage/gw-portals-viewmodel-js';
import { ServiceManager } from '@jutro/legacy/services';
import styles from './MLTileComponent.module.scss';
import { Icon } from '@jutro/legacy/components';
import { TranslatorContext } from '@jutro/legacy/locale';

class MLTileComponent extends Component {
    /**
     * @memberof gw-components-platform-react.TilesComponent
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {string} propTypes.id - id of the component
     * @prop {string} propTypes.title - title of the component
     * @prop {number} propTypes.value - value of the component
     * @prop {string} propTypes.tileIcon - material-ui icon that need to be displayed in component
     * @prop {boolean} propTypes.redirect - enable/disable page redirect
     * @prop {string} propTypes.redirectPath - used when redirect prop is set to true
     * @prop {string} propTypes.tileSize - size of tile - large/medium
     * @prop {function} propTypes.onClick - callback when tile is clicked
     * @prop {boolean} propTypes.active - mark tile as selected
     * @prop {string} propTypes.mlTagManagerLinkClick - string for tag manager.
     */

    static propTypes = {
        id: PropTypes.string.isRequired,
        title: PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string
        }).isRequired,
        value: PropTypes.number,
        tileIcon: PropTypes.string,
        redirect: PropTypes.bool.isRequired,
        redirectPath: PropTypes.string,
        tileSize: PropTypes.string,
        onClick: PropTypes.func,
        active: PropTypes.bool,
        isContact: PropTypes.bool,
        mlTagManagerLinkClick: PropTypes.string,
        contactDetails: PropTypes.shape({
            workNumber: PropTypes.string,
            homeNumber: PropTypes.string,
            cellNumber: PropTypes.string,
            emailAddress1: PropTypes.string,
            primaryPhoneType: PropTypes.string,
            primaryAddress: PropTypes.shape({
                city: PropTypes.string,
                state: PropTypes.string,
                postalCode: PropTypes.string,
                addressLine1: PropTypes.string,
                addressLine2: PropTypes.string,
                addressLine3: PropTypes.string,
            }),
        }),
        showErrorIcon: PropTypes.bool
    };

    formatContactPhone = (accountHolder) => {
        const phoneUtil = PhoneUtil();
        const localeService = ServiceManager.getService('locale-service');
        const defaultCountryCode = localeService.getDefaultCountryCode()
        let primaryPhoneNumber = ''
        if (accountHolder.primaryPhoneType === 'work' && accountHolder.workNumber && accountHolder.workNumber.length > 0) {
            primaryPhoneNumber = phoneUtil.prettyPrint(accountHolder.workNumber, defaultCountryCode);
        } else if (accountHolder.primaryPhoneType === 'home' && accountHolder.homeNumber && accountHolder.homeNumber.length > 0) {
            primaryPhoneNumber = phoneUtil.prettyPrint(accountHolder.homeNumber, defaultCountryCode);
        } else if (accountHolder.primaryPhoneType === 'mobile' && accountHolder.cellNumber && accountHolder.cellNumber.length > 0) {
            primaryPhoneNumber = phoneUtil.prettyPrint(accountHolder.cellNumber, defaultCountryCode);
        }
        return `${primaryPhoneNumber} (${accountHolder.primaryPhoneType})`;
    }

    formatContactAddress = (accountHolder) => {
        return `${accountHolder.primaryAddress.city}, ${accountHolder.primaryAddress.state} ${accountHolder.primaryAddress.postalCode}`;
    }

    static defaultProps = {
        value: null,
        tileIcon: '',
        redirectPath: '#',
        onClick: null,
        active: false,
        isContact: false,
        contactDetails: {},
        mlTagManagerLinkClick: null,
        showErrorIcon: false
    };

    tileClicked = () => {
        const {redirect, redirectPath, history} = this.props;
        if(redirect && redirectPath){
            history.push(redirectPath);
        }
    };

    renderContent = () => {
        const {
            title, isContact, contactDetails, showErrorIcon
        } = this.props;
        if (isContact) {
            return (
                <TranslatorContext.Consumer>
                    {(translator) => {
                        return (
                            <div>
                                {translator(title)}
                                <p><i className="icon icon-ml-phone" />{this.formatContactPhone(contactDetails)}</p>
                                <p><i className="icon icon-ml-letter" />{contactDetails.emailAddress1}</p>
                                <p><i className="icon icon-ml-location" />{contactDetails.primaryAddress.addressLine1}</p>
                                {(contactDetails.primaryAddress.addressLine2 !== undefined) ? <p className="no-icon">{contactDetails.primaryAddress.addressLine2}</p> : <></>}
                                {(contactDetails.primaryAddress.addressLine3 !== undefined) ? <p className="no-icon">{contactDetails.primaryAddress.addressLine3}</p> : <></>}
                                <p className="no-icon">{this.formatContactAddress(contactDetails)}</p>
                            </div>
                        );
                    }}
                </TranslatorContext.Consumer>
            );
        }

        if (showErrorIcon === true) {
            return (
                <TranslatorContext.Consumer>
                    {(translator) => {
                        return (
                            <span>{translator(title)} <Icon icon="mi-error-outline" className={styles.errorIcon}/></span>
                        );
                    }}
                </TranslatorContext.Consumer>
            );
        }

        return (
            <TranslatorContext.Consumer>
                {(translator) => {
                    return (
                        <span>{translator(title)}</span>
                    );
                }}
            </TranslatorContext.Consumer>
        );
    };

    render() {
        const {mlTagManagerLinkClick, className } = this.props;

        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li role="button" tabindex="0" className={className} onClick={this.tileClicked} mlTagManagerLinkClick={mlTagManagerLinkClick}>
                {this.renderContent()}
            </li>
        );
    }
}

export default withRouter(MLTileComponent);
